<app-responsiveroomchampions
  [roomChampions]="(roomchampions$ | async)!"
  [loading]="!!(loading$ | async)"
  [theme]="theme"
  [month]="month"
></app-responsiveroomchampions>
